import styled from "styled-components";

import { Artifact, ArtifactProjectTypeLabel } from "../../models";

const ProductType = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  border: 0.5px solid rgba(0, 0, 0, 0.13);
  background: rgba(255, 255, 255);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: 500;
  font-size: 12px;

  margin-left: -5px;
`;

type Props = {
  artifacts: Artifact[];
};

const ProductTypeBadges = ({ artifacts }: Props): JSX.Element => (
  <>
    {artifacts.slice(0, 3).map((artifact) => (
      <ProductType key={artifact.id}>
        {ArtifactProjectTypeLabel[artifact.artifactProjectType || "-"] || "-"}
      </ProductType>
    ))}
    {artifacts.length > 3 && (
      <ProductType key="extra">+{artifacts.length - 3}</ProductType>
    )}
  </>
);

export default ProductTypeBadges;
